import { memo } from "react";
import { Route, Routes } from "react-router-dom";
import PropTypes from "prop-types";
import { brandPropTypes } from "app/utils/propTypes";
import { BRANDS } from "app/constants";
import PrivateRoute from "app/pages/.shared/PrivateRoute";
import {
	AsyncCustomerRequestFormContainer,
	AsyncAccountFaqContactContainer,
	AsyncMyBookingPageContainer,
	AsyncMyBookingsContainer,
	AsyncMyCreditsContainer,
	AsyncMyRefundsContainer,
	AsyncParrainageContainer,
	AsyncProfileContainer,
	AsyncSecurityContainer,
	AsyncSubscriptionsContainer,
} from "app/routes";
import AccountAsideMenuAuthenticatedContainer from "app/pages/Account/AccountAsideMenu/AccountAsideMenuAuthenticatedContainer";
import AccountAsideMenuUnauthenticatedContainer from "app/pages/Account/AccountAsideMenu/AccountAsideMenuUnauthenticatedContainer";

import "./Account.scss";

const Account = ({ brand, enableSponsorship = false, isAuthenticated = false, isSdp = false }) => {
	const isBrandXX = brand === BRANDS.XX;

	const authPath = brand === BRANDS.TO ? "/booking-auth" : "/auth";

	let routes = (
		<Routes>
			<Route
				path="/profile"
				element={
					<PrivateRoute authPath={authPath}>
						<AsyncProfileContainer />
					</PrivateRoute>
				}
			/>
			<Route
				path="/customer-request/:request"
				element={
					isSdp ? (
						<AsyncCustomerRequestFormContainer />
					) : (
						<PrivateRoute authPath={authPath}>
							<AsyncCustomerRequestFormContainer />
						</PrivateRoute>
					)
				}
			/>

			<Route path="/mybookings/:bookingReference" element={<AsyncMyBookingPageContainer />} />
			<Route
				path="/mybookings"
				element={
					<PrivateRoute authPath={authPath}>
						<AsyncMyBookingsContainer />
					</PrivateRoute>
				}
			/>
			<Route
				path="/security"
				element={
					<PrivateRoute authPath={authPath}>
						<AsyncSecurityContainer />
					</PrivateRoute>
				}
			/>
			<Route
				path="/subscriptions"
				element={
					<PrivateRoute authPath={authPath}>
						<AsyncSubscriptionsContainer />
					</PrivateRoute>
				}
			/>
			{enableSponsorship && (
				<Route path="/sponsorship/*" element={<AsyncParrainageContainer />} />
			)}
			<Route
				path="/mycredits"
				element={
					<PrivateRoute authPath={authPath}>
						<AsyncMyCreditsContainer />
					</PrivateRoute>
				}
			/>
			<Route
				path="/myrefunds"
				element={
					<PrivateRoute authPath={authPath}>
						<AsyncMyRefundsContainer />
					</PrivateRoute>
				}
			/>
			<Route path="/faq-contact" element={<AsyncAccountFaqContactContainer />} />
		</Routes>
	);

	if (isBrandXX) {
		routes = (
			<Routes>
				<Route
					path="/mybookings/:bookingReference"
					element={<AsyncMyBookingPageContainer />}
				/>
				<Route
					path="/mybookings"
					element={
						<PrivateRoute authPath={authPath}>
							<AsyncMyBookingsContainer />
						</PrivateRoute>
					}
				/>
				<Route
					path="/customer-request/:request"
					element={<AsyncCustomerRequestFormContainer />}
				/>
				<Route
					path="/myrefunds"
					element={
						<PrivateRoute authPath={authPath}>
							<AsyncMyRefundsContainer />
						</PrivateRoute>
					}
				/>
				<Route path="/faq-contact" element={<AsyncAccountFaqContactContainer />} />
			</Routes>
		);
	}

	return (
		<div className="account">
			<div className="account__container">
				<div className="account__aside">
					{isAuthenticated ? (
						<AccountAsideMenuAuthenticatedContainer />
					) : (
						<AccountAsideMenuUnauthenticatedContainer />
					)}
				</div>
				<div className="account__main">{routes}</div>
			</div>
		</div>
	);
};

Account.propTypes = {
	brand: brandPropTypes,
	isAuthenticated: PropTypes.bool,
	enableSponsorship: PropTypes.bool,
	isSdp: PropTypes.bool,
};

export default memo(Account);
